import { useNavigate } from "react-router-dom";
import { Building2, Clock, GraduationCap, MapPin, Wallet, Zap } from "lucide-react";
import { Badge } from "@/components/ui/badge";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
import { ShareButton } from "@/components/common/ShareButton";
import { LiveBadge } from "@/components/jobs/LiveBadge";
import { formatSalary } from "@/lib/constants";

export const JobCard = ({ job, onInterested }) => {
  const navigate = useNavigate();
  const jobUrl = `${window.location.origin}/jobs/${job.id}`;
  const shareText = `${job.title} at ${job.hiring_brand} – Apply now:`;
  return (
    <Card className="rounded-xl border-border shadow-none hover:shadow-[var(--shadow-sm)] hover:border-primary/40 transition-all h-full flex flex-col" data-testid="job-card">
      <CardContent className="p-5 flex flex-col flex-1">
        <div className="flex items-start justify-between gap-2">
          <Badge variant="outline" className="rounded-full text-xs bg-blue-50 text-blue-700 border-blue-200">
            <Building2 className="h-3 w-3 mr-1" /> {job.hiring_brand}
          </Badge>
          <LiveBadge status={job.status} />
        </div>
        <p className="font-heading font-semibold text-lg mt-3 leading-tight" data-testid="job-card-title">{job.title}</p>
        <p className="text-sm font-medium text-emerald-700 mt-1.5 flex items-center gap-1.5">
          <Wallet className="h-3.5 w-3.5" /> {formatSalary(job.salary_min, job.salary_max)}
        </p>
        <div className="grid grid-cols-2 gap-x-3 gap-y-1.5 mt-3 text-xs text-muted-foreground">
          <span className="flex items-center gap-1.5"><MapPin className="h-3.5 w-3.5 shrink-0" />{job.location}</span>
          <span className="flex items-center gap-1.5"><Zap className="h-3.5 w-3.5 shrink-0" />{job.experience}</span>
          <span className="flex items-center gap-1.5"><GraduationCap className="h-3.5 w-3.5 shrink-0" />{job.education}</span>
          <span className="flex items-center gap-1.5"><Clock className="h-3.5 w-3.5 shrink-0" />{job.shift}</span>
        </div>
        <div className="flex gap-2.5 mt-5 pt-4 border-t border-border mt-auto">
          <Button variant="outline" size="sm" className="flex-1 rounded-lg bg-white" onClick={() => navigate(`/jobs/${job.id}`)} data-testid="job-card-details-button">
            More Details
          </Button>
          <Button size="sm" className="flex-1 rounded-lg" onClick={onInterested} data-testid="job-card-interested-button">
            I'm Interested
          </Button>
          <ShareButton url={jobUrl} text={shareText} testIdPrefix="job-card-share" iconOnly />
        </div>
      </CardContent>
    </Card>
  );
};
